import React, {useEffect} from 'react';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import * as Colors from "@mui/material/colors";
import ChatBubble from "@mui/icons-material/ChatBubble";
import {closeDrawer} from "../../actions/drawerActions";
import {getQuestionnaireNotes, getAllQuestionnaireNotes} from "../../actions/questionnaireTemplateActions";
import {toLocale} from "../../utilities/dateFormats";
import ArgoAppBarHook from "../common/ArgoAppBarHook";
import ClickAwayListener from '@mui/material/ClickAwayListener';
import ArgoDividerWithLabelHook from "../common/ArgoDividerWithLabelHook";


const QuestionnaireNoteHistoryDrawer = ({
                                            closeDrawer,
                                            templateId,
                                            getQuestionnaireNotes,
                                            getAllQuestionnaireNotes,
                                            notes,
                                            template
                                        }) => {
    // Replace deprecated componentWillMount with useEffect
    // Empty dependency array ensures this runs only once on mount
    useEffect(() => {
        if (Number.isInteger(templateId)) {
            getQuestionnaireNotes(templateId);
        } else getAllQuestionnaireNotes(templateId)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                e.preventDefault()
                closeDrawer()
            }
        }

        document.addEventListener("keydown", handleKeyDown, true)

        return () => {
            document.removeEventListener("keydown", handleKeyDown, true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    let nameAndQualifier = `${template.name} -${template.nameQualifier}`
    return (
        <ClickAwayListener onClickAway={closeDrawer}>
            <div style={{height: "100%"}}>
                <ArgoAppBarHook
                    title={"Note History:"}
                    titleFor={template.name}
                    qualifierFor={template.nameQualifier}
                    showMenuArrowButton="LEFT"
                    onLeftIconButtonTouchTap={closeDrawer}
                    isDrawer={true}
                    width={questionnaireNoteHistoryDrawerProps.width}
                />
                <div style={{height: '64px'}}></div>
                <div style={{height: "100%"}}>
                    {notes.versionNote.length > 0 ?
                        notes.versionNote.map(note => {
                            return (
                                <Card key={note.action} style={{margin: "16px"}}>
                                    <CardContent>
                                        <div style={{
                                            display: "flex",
                                            alignItems: "center",
                                            height: "24px",
                                            paddingBottom: "16px"
                                        }}>
                                            <ChatBubble color={Colors.grey[500]}/><span>{note.actionLabel}</span>
                                        </div>
                                        <div style={{paddingBottom: "16px"}}>
                                            {"Updated by " + note.user + " on " + toLocale(note.date)}
                                        </div>
                                        {note.text.includes("||") ?
                                            <div>
                                                <div
                                                    style={{paddingBottom: "16px"}}>{note.text.slice(0, note.text.indexOf("||") - 1)}</div>
                                                <div>Note: {note.text.slice(note.text.indexOf("||") + 2)}</div>
                                            </div>
                                            : note.text.includes("- null") ?
                                                <div>{note.text.slice(0, -7)}</div>
                                                :
                                                <div>
                                                    <div
                                                        style={{paddingBottom: "16px"}}>{note.text.slice(0, note.text.lastIndexOf("-") - 1)}</div>
                                                    <div>Note: {note.text.slice(note.text.lastIndexOf("-") + 2)}</div>
                                                </div>
                                        }
                                    </CardContent>
                                </Card>);
                        })
                        :
                        notes.allNotes.map(version => {
                            let dividerDisplay = ""
                            if (`${version.name} -${version.nameQualifier}` === nameAndQualifier) dividerDisplay = ""
                            else {
                                dividerDisplay = (
                                    <span style={{display: "flex", alignItems: "center", gap: "4px"}}>
                                        <span
                                            style={{
                                                maxWidth: "450px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                display: "inline-block"
                                            }}
                                            title={version.name}
                                        >
                                            {version.name}
                                        </span>
                                        <span>-</span>
                                        <span
                                            style={{
                                                maxWidth: "350px",
                                                whiteSpace: "nowrap",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                display: "inline-block"
                                            }}
                                            title={version.nameQualifier}
                                        >
                                            {version.nameQualifier}
                                        </span>
                                    </span>
                                )
                                nameAndQualifier = `${version.name} -${version.nameQualifier}`
                            }

                            return (
                                <div key={version.id}>
                                    {dividerDisplay !== "" ? <ArgoDividerWithLabelHook
                                        fileName="QuestionnaireNoteHistoryDrawerHook"
                                        margin={"16px"}
                                        label={dividerDisplay}
                                    /> : ""}
                                    {version.audits.map(note => (
                                        <Card key={version.id + note.action} style={{margin: "16px"}}>
                                            <CardContent>
                                                <div style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    height: "24px",
                                                    paddingBottom: "16px"
                                                }}>
                                                    <ChatBubble
                                                        color={Colors.grey[500]}/><span>{note.actionLabel}</span>
                                                </div>
                                                <div style={{paddingBottom: "16px"}}>
                                                    {"Updated by " + note.user + " on " + toLocale(note.date)}
                                                </div>
                                                {note.text.includes("||") ?
                                                    <div>
                                                        <div
                                                            style={{paddingBottom: "16px"}}>{note.text.slice(0, note.text.indexOf("||") - 1)}</div>
                                                        <div>Note: {note.text.slice(note.text.indexOf("||") + 2)}</div>
                                                    </div>
                                                    : note.text.includes("- null") ?
                                                        <div>{note.text.slice(0, -7)}</div>
                                                        :
                                                        <div>
                                                            <div
                                                                style={{paddingBottom: "16px"}}>{note.text.slice(0, note.text.lastIndexOf("-") - 1)}</div>
                                                            <div>Note: {note.text.slice(note.text.lastIndexOf("-") + 2)}</div>
                                                        </div>
                                                }
                                            </CardContent>
                                        </Card>
                                    ))}
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </ClickAwayListener>
    );
};

QuestionnaireNoteHistoryDrawer.propTypes = {
    closeDrawer: PropTypes.func,
    templateId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    notes: PropTypes.object,
    template: PropTypes.object,
    getQuestionnaireNotes: PropTypes.func,
    getAllQuestionnaireNotes: PropTypes.func
};

function mapStateToProps(state) {
    return {
        notes: state.notes,
        template: state.openCloseSecondaryDrawer.template
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({closeDrawer, getQuestionnaireNotes, getAllQuestionnaireNotes}, dispatch);
}

const questionnaireNoteHistoryDrawerProps = {
    opensecondary: true,
    width: "55%",
    docked: false,
    anchor: "right"
};

export default connect(mapStateToProps, mapDispatchToProps)(QuestionnaireNoteHistoryDrawer);
export {questionnaireNoteHistoryDrawerProps};
